"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapperPageWithCSR = exports.wrapperPageWithSSR = void 0;
var React = require("react");
var queryString = require("query-string");
var joinPath_1 = require("../utils/joinPath");
var useEffect = React.useEffect, useState = React.useState;
function formatRoutes(routes, parentPath) {
    return routes.map(function (item) {
        if (item.path) {
            var routePath = joinPath_1.default(parentPath || '', item.path);
            item.path = routePath === '/' ? '/' : routePath.replace(/\/$/, '');
        }
        if (item.children) {
            item.children = formatRoutes(item.children, item.path);
        }
        else if (item.component) {
            var itemComponent = item.component;
            itemComponent.pageConfig = Object.assign({}, itemComponent.pageConfig, { componentName: itemComponent.name });
        }
        return item;
    });
}
exports.default = formatRoutes;
function wrapperPageWithSSR(context) {
    var pageInitialProps = __assign({}, context.pageInitialProps);
    var WrapperPageFn = function (PageComponent) {
        var ServerWrapperedPage = function (props) {
            return React.createElement(PageComponent, __assign({}, Object.assign({}, props, pageInitialProps)));
        };
        return ServerWrapperedPage;
    };
    return WrapperPageFn;
}
exports.wrapperPageWithSSR = wrapperPageWithSSR;
function wrapperPageWithCSR() {
    var _this = this;
    var wrapperPage = function (PageComponent) {
        var pageConfig = PageComponent.pageConfig;
        var _a = pageConfig || {}, title = _a.title, scrollToTop = _a.scrollToTop;
        var RouterWrapperedPage = function (props) {
            var _a = useState(window.__ICE_PAGE_PROPS__), data = _a[0], setData = _a[1];
            useEffect(function () {
                if (title) {
                    document.title = title;
                }
                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
                // When enter the page for the first time, need to use window.__ICE_PAGE_PROPS__ as props
                // And don't need to re-request to switch routes
                // Set the data to null after use, otherwise other pages will use
                if (window.__ICE_PAGE_PROPS__) {
                    window.__ICE_PAGE_PROPS__ = null;
                }
                else if (PageComponent.getInitialProps) {
                    // When the server does not return data, the client calls getinitialprops
                    (function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, href, origin, pathname, search, curPath, query, ssrError, initialContext, result;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = window.location, href = _a.href, origin = _a.origin, pathname = _a.pathname, search = _a.search;
                                    curPath = href.replace(origin, '');
                                    query = queryString.parse(search);
                                    ssrError = window.__ICE_SSR_ERROR__;
                                    initialContext = {
                                        pathname: pathname,
                                        path: curPath,
                                        query: query,
                                        ssrError: ssrError
                                    };
                                    return [4 /*yield*/, PageComponent.getInitialProps(initialContext)];
                                case 1:
                                    result = _b.sent();
                                    setData(result);
                                    return [2 /*return*/];
                            }
                        });
                    }); })();
                }
            }, []);
            return React.createElement(PageComponent, __assign({}, Object.assign({}, props, data)));
        };
        return RouterWrapperedPage;
    };
    return wrapperPage;
}
exports.wrapperPageWithCSR = wrapperPageWithCSR;
